const wasPartialApproval = (state, action) => {
    if (state === undefined) {
        return false;
    }
    switch (action.type) {
        case 'CREATE_RESULT_OF_PAY':
            if (action.payload?.transaction?.status === 'partial_approved') {
                return true;
            }
            return state.wasPartialApproval;
        default:
            return state.wasPartialApproval;
    }
};

export { wasPartialApproval };
